<template>
  <div>
    <el-divider v-if="!onOff">
      <el-button plain size="mini" data-type="1" @click = "pageUp">加载更多
        <i class="iconfont icon-arrow-down"></i>
      </el-button>
    </el-divider>
    <el-divider v-else>
      没有更多啦！
    </el-divider>
  </div>
</template>

<script>
export default {
  name: 'Page',
  props: {
    list: { // 数据列表
      type: Array,
      required: true
    },
    limit: { // 每页条目数
      type: Number,
      required: true
    },
    type: {
    }
  },
  data () {
    return {
      num: 1,
      onOff: false,
      length: 0
    }
  },
  created () {
    if (this.list.length < this.limit) {
      this.onOff = true
    } else {
      this.length = this.list.length
    }
  },
  computed: {
    testDataNew () {
      return JSON.parse(JSON.stringify(this.list))
    }
  },
  watch: {
    list: {
      handler: function (newList, oldList) {
        if (newList.length > this.length) {
          if ((newList.length - this.length) === this.limit) {
            this.length = newList.length
            this.onOff = false
          } else {
            this.onOff = true
          }
        } else {
          this.onOff = true
        }
      }
    }
  },
  methods: {
    pageUp: function () {
      this.num++
      this.$emit('page', this.num) // 当页面只有一个列表时
      this.$emit('pageType', this.num, this.type) // 页面有多个列表
      this.onOff = this.pageOnOff()
    },
    pageOnOff: function () {
      this.onOff = true
    }
  }
}
</script>

<style>
</style>
